export const commentsPanelPath = `/comments`;

const CommentsRoutes = {
  commentsPanel: {
    path: commentsPanelPath,
  },
};

export default CommentsRoutes
